import { useGetAssetType } from "@/entities/asset-type";
import { AppLayoutPage } from "@/modules/app-layout/app-layout-page";
import { PageItemGate } from "@/modules/page-item-gate";
import { useIdParam } from "@/services/router";

import { AssetTypePageHeader } from "./asset-type-page-header";
import { AssetTypePageTabs } from "./asset-type-page-tabs";

const AssetTypePage = () => {
  const id = useIdParam();

  const { isLoading, assetType, error } = useGetAssetType(id);

  return (
    <PageItemGate model="assettype" queryError={error}>
      <AssetTypePageHeader assetType={assetType} loading={isLoading} />
      <AppLayoutPage>
        <AssetTypePageTabs assetType={assetType} loading={isLoading} />
      </AppLayoutPage>
    </PageItemGate>
  );
};

export default AssetTypePage;
